import { getAll, get } from "@/utilities/querySelector";

/**
 * Open modal
 */
getAll( '.open-modal' ).forEach( opener => {
    opener.addEventListener( 'click', function() {
        const id = opener.getAttribute( 'modal-id' );
        get( `.modal#${id}` )?.style?.setProperty( 'display', '' );
    } );
} );

/**
 * Close modal on x click
 */
getAll( '.modal-close' ).forEach( closer => {
    closer.addEventListener( 'click', function() {
        const modal = /** @type {HTMLElement} */ ( closer.closest( '.modal' ) );
        modal.style.display = 'none';
    } );
} );

/**
 * Make .modal-sliders slick sliders.
 */
const modals = getAll( '.modals' );
modals.forEach( modal => {
    const slider = get( '.modal-slider', modal );
    if ( !slider ) return;
    const nextArrow = get( '.arrows .next', modal );
    const prevArrow = get( '.arrows .prev', modal );

    jQuery( modal ).slick( {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow,
        nextArrow,
    } );
} );
